<template>
  <div v-loading="loading">
    <el-table
      v-if="tableConfig"
      :key="tableKey"
      :data="tourCalendars.data"
      style="width: 100%"
      row-key="id"
      @sort-change="handleSortChange"
    >
      <component
        :is="column.value"
        v-for="column in tableConfig.columns"
        :key="column.value"
      />
      <el-table-column
        fixed="right"
        label=""
        width="180"
        style="text-align: right;"
      >
        <template
          slot="header"
          slot-scope="scope"
        >
          <table-settings
            v-if="tableConfig"
            :config="tableConfig"
            :allcolumns="allColumns"
            :labels="labels"
            store-module="tourCalendar"
            :options="['settings']"
          />
        </template>
        <template
          slot-scope="scope"
        >
          <Actions :tour-calendar="scope.row" />
        </template>
      </el-table-column>
    </el-table>
    <div class="el-card-footer">
      <el-pagination
        background
        :current-page.sync="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="tourCalendars.per_page"
        layout="total, prev, pager, next"
        :total="tourCalendars.total"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
  import Actions from './Actions';
  import TableSettings from '../../TableSettings';
  import columns, { allColumns, labels } from './columns';

  export default {
    components: {
      Actions,
      TableSettings,
      ...columns,
    },
    data() {
      return {
        labels,
        allColumns,
        tableKey: 0,
        currentPage: 1,
        currentSort: {
          prop: 'start_date',
          order: 'ascending',
        },
      };
    },
    computed: {
      tourCalendars() {
        return this.$store.getters['tourCalendar/tourCalendars'];
      },
      tableConfig() {
        return JSON.parse(JSON.stringify(this.$store.getters['tourCalendar/tableConfig']));
      },
      loading() {
        return this.$store.getters['tourCalendar/loading'];
      },
    },
    watch: {
      tableConfig() {
        this.tableKey++;
      },
    },
    async mounted() {
      this.$store.commit('tourCalendar/setFilterString', '');
      this.$store.commit('tourCalendar/setCurrentPage', this.currentPage);
      this.$store.commit('tourCalendar/setSorting', this.currentSort);
      await this.$store.dispatch('tourCalendar/fetchAll');
    },
    methods: {
      handleCurrentChange(val) {
        this.$store.commit('tourCalendar/setCurrentPage', val);
        this.$store.dispatch('tourCalendar/fetchAll');
      },
      handleSortChange({ column, prop, order }) {
        if (column.sortable === 'custom') {
          this.$store.commit('tourCalendar/setSorting', { prop, order });
          this.$store.dispatch('tourCalendar/fetchAll');
        }
      },
    },
  };
</script>

